<template>
  <div class="flex flex-1 flex-col gap-1">
    <div class="text-orange-900/60 text-xs">
      {{ label }}
    </div>
    <div><slot /></div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  label: string;
}>();
</script>
